import getUsersAge from './getUsersAge';
import { ADULT } from '../constants/patientAges';
import * as _ from "lodash"

export default function getUsersType(birthday) {
    const age = getUsersAge(birthday);
    return _.isNumber(age) ? (age <= ADULT ? "Child" : "Adult") : '-';
}